export const mapInitialValues = (initialValues) => {
  const mappedInitialValues = {
    ...initialValues,
    category_uid: initialValues?.category?.uid,
  };

  return mappedInitialValues;
};
